import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { ScreenLoader } from '@/components/loaders';
import { usePortal } from './PortalProvider';

/** The signed-in part of the portal. Anyone else goes to the portal's sign-in page. */
const RequirePortalSession = () => {
  const { guest, loading } = usePortal();
  const location = useLocation();

  if (loading) {
    return <ScreenLoader />;
  }

  if (!guest) {
    return <Navigate to="/portal/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
};

export { RequirePortalSession };
